import { TFunction } from "i18next";
import { map } from "lodash";
import { SalesQuoteTakeOffTemplate } from "../../../../models/salesQuote";
import { GenericFormFields } from "../../../generic-form/GenericFormBody";

export const importTakeOffFromTemplateFields = (
  t: TFunction,
  takeoffTemplates: SalesQuoteTakeOffTemplate[]
): GenericFormFields<{ templateId: string }> => {
  const takeOffTemplate = map(takeoffTemplates, (template) => ({
    value: template._id,
    label: template.name,
  }));
  return {
    templateId: {
      type: "default-select",
      label: t("common.template"),
      placeholder: t("common.template"),
      valueKey: "templateId",
      selectProps: {
        options: takeOffTemplate,
      },
    },
  };
};
